import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { CarteiraRecomendadaProvider } from 'projects/core/src/lib/core/provider/CarteiraRecomendadaProvider';
import { AtivoModel } from 'projects/core/src/lib/core/model/AtivoModel';
import { RecomendacaoAtivoProvider } from 'projects/core/src/lib/core/provider/RecomendacaoAtivoProvider';
import { OptionsStrategyComponent } from './options-strategy.component';
import { RecomendacaoOpcoesModel } from 'projects/core/src/lib/core/model/RecomendacaoOpcoesModel';

export class OptionsRecommentationsViewModel {
    carteiraRecomendadaProvider = new CarteiraRecomendadaProvider()
    RecomendacaoAtivoProvider = new RecomendacaoAtivoProvider()

    webSocket: WebSocket = null
    tryReconnect = 0

    constructor() { }

    recomendacaoModel = new RecomendacaoOpcoesModel()
    context: OptionsStrategyComponent

    setContext(context: OptionsStrategyComponent) {
        this.context = context
    }

    getContext(): OptionsStrategyComponent {
        return this.context
    }

    async getAtivo(idAtivo: Number) {
        try {
            let retorno = await this.recomendacaoModel.getAtivoPorId(idAtivo)
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                console.log(retorno.data);

                this.getContext().setAtivo(retorno.data)
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) {
            throw new Error(ThrowError.MESSAGE_DEFAULT)
        }
    }

    async initWebSocket(callback = null) {
        let self = this
        this.webSocket = await this.carteiraRecomendadaProvider.connectWebsocket()
        this.webSocket.onmessage = function (event) {
            self.handlerWebSocketMessage(event.data);
        }
        this.webSocket.onopen = function (evt) {
            console.log("onopen.");
            if (callback != null) callback()
        };
        this.webSocket.onclose = function (evt) {
            console.log("onclose.");
        };
        this.webSocket.onerror = function (evt) {
            console.log("Error!");
            if (self.tryReconnect < 3) {
                self.tryReconnect++;
                self.initWebSocket(callback)
            } else if (self.tryReconnect < 6) {
                setTimeout(() => {
                    self.tryReconnect++;
                    self.initWebSocket(callback)
                }, 5000)
            }
        };
    }

    handlerWebSocketMessage(data) {
        let split = data.split(":")
        let codigo_ativo = split[1]
        let cotacao = split[2]
        let variacao = split[3]
        let ativo = this.getContext().ativo

        // if (ativo.ativo_objeto.codigo === codigo_ativo && ativo.ativo_objeto.preco_atual != cotacao) {
        if (ativo.pontas.some(ponta => ponta.codigo === codigo_ativo) && ativo.pontas.some(ponta => ponta.preco_atual != cotacao)) {

            let contacaoWS = parseFloat(cotacao)
            let variacaoWS = parseFloat(variacao)

            // if (!ativo.encerrada) {
            //     ativo.objetivos.forEach((item) => {
            //         if (!item.atingido && ((contacaoWS >= item.valor && ativo.compra == 1) || (contacaoWS <= item.valor && ativo.compra == 0))) {
            //             this.getContext().showToast(`${item.nome} atingido com sucesso!`)
            //             item.atingido = true
            //         }
            //     })
            // }

            const index = ativo.pontas.findIndex((e) => e.codigo === codigo_ativo)
            ativo.pontas[index].preco_atual = contacaoWS
            // ativo.pontas[codigo_ativo]variacao = variacaoWS

            if (!this.getContext().ativo.encerrada) {
                console.log('mostrar?')
                if (!this.getContext().ativo?.atingido && ((this.getContext().ativo.preco_atual >= this.getContext().ativo.objetivo_estrutura && this.getContext().ativo.compra == 1) || (this.getContext().ativo.preco_atual <= this.getContext().ativo.objetivo_estrutura && this.getContext().ativo.compra == 0))) {
                    console.log('Sim, mostra')
                    console.log('antes ',this.getContext().ativo.atingido)
                    this.getContext().showToast(`${this.getContext().ativo.ativo_objeto.codigo} atingido com sucesso!`)
                    this.getContext().ativo.atingido = true
                    console.log('depois ',this.getContext().ativo.atingido)
                }
            }

            ativo.viewEstadoCor = true
            setTimeout(() => {
                ativo.viewEstadoCor = false
            }, 1500)
        }
    }

    finishWebSocket() {
        if (this.webSocket != null) {
            this.webSocket.close()
        }
    }

    sendMessageSocketByTipoAtivo(ativos: Array<String>) {
        this.webSocket.send("L:" + ativos.toString())
    }

    async salvaItemFavorito(item: AtivoModel, tipoAtivo: String) {
        await this.RecomendacaoAtivoProvider.salvaItemFavorito(item, tipoAtivo)
    }

    getChaveSessaoPorTipoAtivo(tipoAtivo) {
        return this.RecomendacaoAtivoProvider.getChaveSessaoPorTipoAtivo(tipoAtivo)
    }

    async getListaFavoritos(tipoAtivo: String) {
        return await this.RecomendacaoAtivoProvider.getListaFavoritos(tipoAtivo)
    }

    async checkIsFavorite(tipoAtivo, idAtivo) {
        return await this.RecomendacaoAtivoProvider.checkIsFavorite(tipoAtivo, idAtivo)
    }
}